import React from "react";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";
import { Navigation } from "lucide-react";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/**
 * Single-property Google Map with a marker + a "Get Directions" button that
 * opens turn-by-turn directions to the stay in Google Maps.
 */
export const PropertyMap = ({ lat, lng, name, height = 300 }) => {
  if (lat == null || lng == null) return null;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

  return (
    <div data-testid="property-map-canvas">
      {KEY ? (
        <div className="relative rounded-2xl overflow-hidden border border-black/10 shadow-sm">
          <APIProvider apiKey={KEY}>
            <Map
              style={{ width: "100%", height }}
              defaultCenter={{ lat, lng }}
              defaultZoom={15}
              gestureHandling="cooperative"
              mapTypeControl={false}
              streetViewControl={false}
              fullscreenControl={true}
              clickableIcons={false}
            >
              <Marker position={{ lat, lng }} title={name || "Stay"} />
            </Map>
          </APIProvider>
        </div>
      ) : (
        <div className="rounded-2xl border border-black/10 bg-paper/70 flex items-center justify-center text-ink-soft text-sm" style={{ height }}>
          Map isn't configured yet.
        </div>
      )}

      <a
        href={directions}
        target="_blank"
        rel="noreferrer"
        data-testid="get-directions-btn"
        className="mt-3 inline-flex items-center gap-2 rounded-full bg-brand text-white font-semibold px-5 py-2.5 text-sm transition-transform hover:-translate-y-0.5 shadow-[0_8px_22px_rgba(255,26,26,0.32)]"
      >
        <Navigation className="w-4 h-4" /> Get Directions
      </a>
    </div>
  );
};

export default PropertyMap;
